import React, {useState} from 'react'
import {AUDIENCE} from '../../utils/constants'
import {FormControlLabel, Stack, Grid, Avatar} from '@mui/material'
import WbTextField from '../common/WbTextField'
import WbCheckbox from '../common/WbCheckbox'
import questionResponseTemplate from '../../utils/questionResponseTemplate'
import {Config} from '../../utils/Config'
import {Emoji} from 'emoji-picker-react'
import IconButton from '@mui/material/IconButton'

export default function MultipleSelectRender({
  question,
  audience,
  updateAnswers,
}) {
  const [value, setValue] = useState([])

  const [followupComment, setFollowupComment] = useState(null)
  const [response, setResponse] = useState({
    ...questionResponseTemplate,
    questionId: question.id,
    hasNumValue: question.hasCustomValue,
    participantTypeText:
      audience === AUDIENCE.STAFF
        ? 'Staff'
        : audience === AUDIENCE.PARENT
          ? 'Parent'
          : 'Pupil',
    questionTypeText: 'Multiple Select',
  })

  const setSelectedValues = (event, option, index) => {
    if (event) {
      setValue([...value, {...option}])

      let resp = {
        ...response,

        [`value${index + 1}`]: option.value,
        [`valueText${index + 1}`]:
          audience === AUDIENCE.STAFF
            ? option.staffText
            : AUDIENCE.PARENT == audience
              ? option.parentText
              : option.pupilText,
        [`numValue${index + 1}`]: question.hasCustomValue
          ? option.numValue
          : null,
      }

      resp['staffQuestion'] = question.staffText
      resp['parentQuestion'] = question.parentText
      resp['studentQuestion'] = question.pupilText

      setResponse({...resp})
      if (updateAnswers) {
        updateAnswers({...resp})
      }
    } else {
      setValue([...value.filter(x => x.value !== option.value)])

      let resp = {
        ...response,
        followupComment:
          value.findIndex(x => x.value === option.value) > -1
            ? null
            : response.followupComment,
        [`value${index + 1}`]: null,
        [`numValue${index + 1}`]: null,
        [`valueText${index + 1}`]: null,
      }
      setResponse({...resp})
      if (updateAnswers) {
        updateAnswers({...resp})
      }
    }
  }

  const DummyImage = ({width, height}) => {
    return (
      <Grid
        container
        direction="row"
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Avatar
          variant="square"
          sx={{
            width: width,
            height: height,
            bgcolor: 'grey.100',
            border: '1px solid #E2E2E2',
          }}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.92773 3.80002V18.2H20.255V3.80002H1.92773ZM3.23683 5.10911H18.9459V14.2112L15.4893 10.7343L15.0186 10.2637L12.0529 13.2294L8.28926 9.42518L7.81864 8.95456L3.23683 13.5364V5.10911ZM16.3277 6.4182C15.9805 6.4182 15.6476 6.55612 15.4021 6.80162C15.1566 7.04713 15.0186 7.3801 15.0186 7.72729C15.0186 8.07448 15.1566 8.40746 15.4021 8.65296C15.6476 8.89846 15.9805 9.03638 16.3277 9.03638C16.6749 9.03638 17.0079 8.89846 17.2534 8.65296C17.4989 8.40746 17.6368 8.07448 17.6368 7.72729C17.6368 7.3801 17.4989 7.04713 17.2534 6.80162C17.0079 6.55612 16.6749 6.4182 16.3277 6.4182ZM7.81864 10.8161L13.8326 16.8909H3.23683V15.3979L7.81864 10.8161ZM15.0186 12.1252L18.9459 16.0525V16.8909H15.6935L12.9732 14.1497L15.0186 12.1252Z"
              fill="#E2E2E2"
            />
          </svg>
        </Avatar>
      </Grid>
    )
  }

  const renderTextTypeOptions = () => {
    return (
      question.isTextOption && (
        <Stack direction="column" spacing={1}>
          {question?.multiOptionResponseAttributes?.map((option, index) => (
            <FormControlLabel
              style={{padding: 5, backgroundColor: 'rgba(0,0,0,0.10)'}}
              control={
                <WbCheckbox
                  checked={value.findIndex(x => x.value === option.value) > -1}
                  value={option}
                  onChange={event => {
                    setSelectedValues(event.target.checked, option, index)
                  }}
                />
              }
              label={
                AUDIENCE.STAFF === audience
                  ? option.staffText
                  : AUDIENCE.PARENT == audience
                    ? option.parentText
                    : option.pupilText
              }
            />
          ))}
        </Stack>
      )
    )
  }

  const renderEmojiTypeOptions = () => {
    return (
      <Stack
        direction="row"
        spacing={{xs: 5, sm: 5, md: 7}}
        useFlexGap
        justifyContent={'center'}
        flexWrap={'wrap'}
        rowGap={{xs: 3, sm: 5, md: 7}}
        mt={2}
      >
        {question?.multiOptionResponseAttributes
          ?.sort((x, y) => x.order - y.order)
          .map((option, index) => (
            <Stack
              direction="column"
              spacing={1}
              alignContent={'center'}
              justifyContent={'center'}
            >
              <div
                style={{
                  border:
                    value.findIndex(x => x.value === option.value) > -1
                      ? '3px solid #E84F6B'
                      : '3px solid transparent',
                  borderRadius: 8,
                }}
              >
                {option.staffEmoji ||
                option.parentEmoji ||
                option.pupilEmoji ? (
                  <IconButton
                    onClick={e => {
                      let v =
                        value.findIndex(x => x.value === option.value) > -1
                      setSelectedValues(!v, option, index)
                    }}
                    disableRipple
                  >
                    <Emoji
                      unified={
                        audience === AUDIENCE.STAFF
                          ? option.staffEmoji
                          : audience === AUDIENCE.PARENT
                            ? option.parentEmoji
                            : option.pupilEmoji
                      }
                      size={66}
                    />
                  </IconButton>
                ) : (
                  <DummyImage width={98} height={72} />
                )}
              </div>
              <div style={{marginTop: 10}}>
                {audience === AUDIENCE.STAFF && option.showStaffEmojiLabel
                  ? option.staffText
                  : ''}
                {audience === AUDIENCE.PARENT && option.showParentEmojiLabel
                  ? option.parentText
                  : ''}
                {audience === AUDIENCE.STUDENT && option.showPupilEmojiLabel
                  ? option.pupilText
                  : ''}
              </div>
            </Stack>
          ))}
      </Stack>
    )
  }

  const renderImageTypeOptions = () => {
    return (
      <Stack
        direction="row"
        columnGap={{xs: 5, sm: 5, md: 7}}
        useFlexGap
        justifyContent={'center'}
        flexWrap={'wrap'}
        rowGap={{xs: 3, sm: 5, md: 7}}
        mt={2}
      >
        {question?.multiOptionResponseAttributes
          ?.sort((x, y) => x.order - y.order)
          .map((option, index) => (
            <Stack
              direction="column"
              spacing={1}
              alignContent={'center'}
              justifyContent={'center'}
            >
              <div
                style={{
                  border:
                    value.findIndex(x => x.value === option.value) > -1
                      ? '2px solid #E84F6B'
                      : '2px solid transparent',
                }}
              >
                <IconButton
                  onClick={e => {
                    let v = value.findIndex(x => x.value === option.value) > -1
                    setSelectedValues(!v, option, index)
                  }}
                  disableRipple
                  sx={{padding: 0}}
                >
                  {option.staffImage ||
                  option.parentImage ||
                  option.pupilImage ? (
                    <img
                      src={`${Config.BASE_URL}/Artifact/download?fileName=${
                        audience === AUDIENCE.STAFF
                          ? option.staffImage
                          : audience === AUDIENCE.PARENT
                            ? option.parentImage
                            : option.pupilImage
                      }`}
                      style={{width: 200, height: 'auto'}}
                    />
                  ) : (
                    <DummyImage width={98} height={72} />
                  )}
                </IconButton>
              </div>
              <div style={{marginTop: 10}}>
                {option.showStaffImageLabel && AUDIENCE.STAFF === audience
                  ? option.staffText
                  : ''}
                {option.showParentImageLabel && AUDIENCE.PARENT === audience
                  ? option.parentText
                  : ''}
                {option.showPupilImageLabel && AUDIENCE.STUDENT === audience
                  ? option.pupilText
                  : ''}
              </div>
            </Stack>
          ))}
      </Stack>
    )
  }

  return (
    <Grid container>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <h1>
          {AUDIENCE.STAFF === audience
            ? question.staffText
            : AUDIENCE.PARENT == audience
              ? question.parentText
              : question.pupilText}
        </h1>
      </Grid>

      {question.image && (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <img
            src={`${Config.BASE_URL}/Artifact/download?fileName=${question.image}`}
            alt="question image"
            style={{width: 150, height: 'auto'}}
          />
        </Grid>
      )}
      {question.hasDescription && (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <p>
            {AUDIENCE.STAFF === audience
              ? question.staffDescription
              : AUDIENCE.PARENT == audience
                ? question.parentDescription
                : question.pupilDescription}
          </p>
        </Grid>
      )}
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <div className="question-type-answer">
          {question.isTextOption && renderTextTypeOptions()}
          {question.isEmojiOption && renderEmojiTypeOptions()}
          {question.isImageOption && renderImageTypeOptions()}

          {question.hasFollowup &&
            value.findIndex(
              x => x.value === question.followupQuestions[0]?.followupValue
            ) > -1 && (
              <Stack direction="column" spacing={2} mt={1}>
                <Stack>
                  <h2>
                    {AUDIENCE.STAFF === audience
                      ? question.followupQuestions[
                          question.followupQuestions.findIndex(
                            x =>
                              value?.findIndex(
                                y => y?.value === x.followupValue
                              ) > -1
                          )
                        ]?.staffFollowupText
                      : AUDIENCE.PARENT == audience
                        ? question.followupQuestions[
                            question.followupQuestions.findIndex(
                              x =>
                                value?.findIndex(
                                  y => y?.value === x.followupValue
                                ) > -1
                            )
                          ]?.parentFollowupText
                        : question.followupQuestions[
                            question.followupQuestions.findIndex(
                              x =>
                                value?.findIndex(
                                  y => y?.value === x.followupValue
                                ) > -1
                            )
                          ]?.pupilFollowupText}
                  </h2>
                </Stack>

                <Stack>
                  <WbTextField
                    value={response.followupComment}
                    onChange={e => {
                      setResponse({
                        ...response,
                        followupComment: e.target.value,
                      })

                      if (updateAnswers) {
                        updateAnswers({
                          ...response,
                          followupComment: e.target.value,
                        })
                      }
                    }}
                  ></WbTextField>
                </Stack>
              </Stack>
            )}
        </div>
      </Grid>
    </Grid>
  )
}
